import { useEffect } from 'react';
import { base44 } from '@/api/base44Client';

/**
 * Owns the browser tab icon for the whole app. Mounted at the app root rather
 * than inside the public site layout, so the MR monogram is served on the venue
 * and admin routes too, not just the public pages.
 *
 * It manages link[rel="icon"] only — never apple-touch-icon, which belongs to
 * the internal screens alone (see InstallMetaManager). If the brand asset can't be
 * read, the static monogram link in index.html simply stays as it is.
 */
export default function BrandFaviconManager() {
  useEffect(() => {
    let cancelled = false;
    let previousHref = null;
    let previousType = null;

    base44.entities.BrandAsset.list()
      .then((records) => {
        if (cancelled) return;
        const favicon = (records || []).find((a) => a.asset_type === 'favicon');
        if (!favicon?.file_url) return;
        const link = document.querySelector('link[rel="icon"]');
        if (!link) return;
        previousHref = link.getAttribute('href');
        previousType = link.getAttribute('type');
        link.setAttribute('href', favicon.file_url);
        link.setAttribute('type', favicon.file_url.endsWith('.svg') ? 'image/svg+xml' : 'image/png');
      })
      .catch(() => { /* the static head tag already serves the monogram */ });

    return () => {
      cancelled = true;
      const link = document.querySelector('link[rel="icon"]');
      if (link && previousHref) {
        link.setAttribute('href', previousHref);
        if (previousType) link.setAttribute('type', previousType);
      }
    };
  }, []);

  return null;
}